<div class="loading-shadow" [ngStyle]=TAP_printStyles()></div>
